<template>
  <div class="animated fadeIn">
    <!-- Cabeçalho -->
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3><i class="fa fa-dashboard"></i> Monitoramento de Sincronizações AD</h3>
            <small>Dashboard de acompanhamento e histórico de sincronizações com Active Directory.</small>
          </div>
          <button
            class="btn btn-third"
            @click="loadData()"
          >
            <i class="fa fa-sync-alt"></i> Atualizar dados
          </button>
        </div>
      </div>
    </div>

    <!-- Cards de Métricas -->
    <MetricsCards ref="metricsCards" :metrics="metrics" @refresh="loadMetrics" @view-details="onViewDetails" />

    <!-- Gráfico de Histórico -->
    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="card-header text-third">
            <strong><i class="fa fa-line-chart"></i> Histórico de Sincronizações (Últimas 30)</strong>
          </div>
          <div class="card-body">
            <ExecutionChart ref="executionChart" :executions="executions" />
          </div>
        </div>
      </div>
    </div>

    <!-- Tabela de Execuções -->
    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="card-header text-third">
            <strong><i class="fa fa-list"></i> Log de Execuções</strong>
          </div>
          <div class="card-body p-0">
            <ExecutionsTable
              ref="executionsTable"
              :executions="executions"
              @view-details="onViewDetails"
              @refresh="loadData"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Detalhes -->
    <ExecutionDetailsModal
      ref="detailsModal"
      :execution-id="selectedExecutionId"
      @hidden="selectedExecutionId = null"
    />
  </div>
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import adSyncService from '@/shared/http/repositories/adsync/adsync'
import MetricsCards from './components/dashboard/MetricsCards.vue'
import ExecutionChart from './components/dashboard/ExecutionChart.vue'
import ExecutionsTable from './components/dashboard/ExecutionsTable.vue'
import ExecutionDetailsModal from './components/dashboard/ExecutionDetailsModal.vue'

export default {
  name: 'SyncMonitoring',
  components: {
    MetricsCards,
    ExecutionChart,
    ExecutionsTable,
    ExecutionDetailsModal
  },
  data () {
    return {
      metrics: null,
      executions: [],
      selectedExecutionId: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData (silent = false) {
      if (!silent) loading.push()

      try {
        await Promise.all([
          this.loadMetrics(),
          this.loadExecutions()
        ])
      } catch (error) {
        console.error('Erro ao carregar dados do dashboard', error)
        if (!silent) {
          toast.error('Erro ao carregar dados do dashboard')
        }
      } finally {
        if (!silent) loading.pop()
      }
    },
    async loadMetrics () {
      try {
        const response = await adSyncService.getDashboardMetrics()
        this.metrics = response.data
      } catch (error) {
        console.error('Erro ao carregar métricas', error)
        throw error
      }
    },
    async loadExecutions () {
      try {
        const response = await adSyncService.getExecutions()
        this.executions = response.data || []
      } catch (error) {
        console.error('Erro ao carregar execuções', error)
        throw error
      }
    },
    onViewDetails (executionId) {
      this.selectedExecutionId = executionId
      this.$nextTick(() => {
        if (this.$refs.detailsModal) {
          this.$refs.detailsModal.show()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ADSync/SyncMonitoring.vue